import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../../styles/About/Route/Experience.scss";

const Experience = ({ darkTheme }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <>
      <div className="experience">
        <div className="experience__container">
          <div className="experience__header">
            <h2 className="experience__number">
              0<span>2</span>
            </h2>
            <h1
              data-aos="fade-down"
              data-aos-offset="0"
              style={{
                display: "inline-block",
                paddingRight: "0.1em", // Add a bit of padding to prevent clipping
                color: darkTheme ? "white" : "transparent",
                background: darkTheme
                  ? "none"
                  : "linear-gradient(167deg, #79a6d2 21%, #ffb3e6)",
                WebkitBackgroundClip: darkTheme ? "none" : "text",
                WebkitTextFillColor: darkTheme ? "white" : "transparent",
              }}
            >
              E<span>xperience</span>.
            </h1>
            <button
              className="experience__close-button"
              onClick={handleGoBack}
              style={{
                background: "none",
                border: "none",
                color: darkTheme ? "white" : "black",
                cursor: "pointer",
                position: "absolute",
                top: "2px",
                right: "20px",
                padding: "10px", // Increase padding for better clickability
              }}
            >
              <FontAwesomeIcon icon={faTimes} size="xl" />
            </button>
          </div>
          <div className="experience__description">
            <div
              className="experience__main-box"
              style={{
                color: darkTheme ? "white" : "black",
                fontWeight: darkTheme ? "none" : 500,
              }}
            >
              <div className="experience__box">
                <h2>Extreme Networks</h2>
                <h3>
                  <FontAwesomeIcon
                    icon={faCalendarDays}
                    className="experience__calendar"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  />
                  &nbsp; &nbsp;03/07/2023 - PRESENT
                </h3>

                <ul>
                  <p
                    style={{
                      color: darkTheme ? "white" : "black",
                      fontWeight: darkTheme ? "none" : 500,
                    }}
                  >
                    Responsible for -
                  </p>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="200"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Built an XGBoost regression model to forecast quarterly Backend Rebate
                      (BER) amounts from historical sales and partner data, enabling finance
                      and sales teams to improve quarterly planning.
                    </span>
                  </li>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="300"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Architected an automated, incremental ETL pipeline using Python and the
                      Microsoft Graph API to securely ingest, chunk, and vectorize thousands
                      of protected enterprise documents from multi-tenant SharePoint sites
                      into Azure AI Search.
                    </span>
                  </li>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="400"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Engineered incremental synchronization using Graph API delta queries
                      with certificate-based MSAL authentication, detecting add/modify/delete
                      events to eliminate full re-crawls and avoid redundant re-embedding of
                      unchanged content.
                    </span>
                  </li>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="500"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Built a RAG-based knowledge engine on Azure OpenAI embeddings and Azure
                      AI Search, powering the Workato Sales Genie assistant that lets sales
                      and partner teams query complex, access-controlled product
                      documentation.
                    </span>
                  </li>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="600"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Improved retrieval quality via hybrid semantic + keyword search with
                      re-ranking and tuned chunk size/overlap strategies, increasing answer
                      accuracy on ambiguous product queries.
                    </span>
                  </li>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="700"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Designed an automated RAG evaluation framework using an
                      LLM-as-a-judge approach, scoring faithfulness, answer relevancy,
                      context precision, and context recall to catch retrieval regressions
                      across releases.
                    </span>
                  </li>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="800"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Built a FastAPI feedback service backed by Azure Cosmos DB and
                      Snowflake to capture user feedback on AI-generated answers, creating a
                      data loop for continuous prompt and retrieval improvement.
                    </span>
                  </li>

                  <li
                    data-aos="fade-right"
                    data-aos-delay="900"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span style={{ color: darkTheme ? "white" : "black" }}>
                      Enabled zero-downtime index deployments using Azure AI Search aliases
                      and instrumented the pipeline with Datadog dashboards to monitor
                      ingestion failures and query latency.
                    </span>
                  </li>
                </ul>
              </div>
              <div className="experience__box">
                <h2>Absolute Foods(ECSO Global)</h2>
                <h3>
                  <FontAwesomeIcon
                    icon={faCalendarDays}
                    className="experience__calendar"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  />
                  &nbsp; &nbsp;01/05/2022 - 28/06/2023
                </h3>
                <ul>
                  <p>Responsible for -</p>
                  <li
                    data-aos="fade-right"
                    data-aos-delay="100"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span
                      style={{
                        color: darkTheme ? "white" : "black",
                        fontWeight: darkTheme ? "none" : 500,
                      }}
                    >
                      Worked on implementation of Pest&Disease Detection Model
                      using Yolov5 and deployed it using Torch Serve.
                    </span>
                  </li>
                  <li
                    data-aos="fade-right"
                    data-aos-delay="200"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span
                      style={{
                        color: darkTheme ? "white" : "black",
                        fontWeight: darkTheme ? "none" : 500,
                      }}
                    >
                      Automated the DSSAT crop simulation model and create an
                      API for it and deployed it using docker.{" "}
                    </span>
                  </li>
                  <li
                    data-aos="fade-right"
                    data-aos-delay="300"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span
                      style={{
                        color: darkTheme ? "white" : "black",
                        fontWeight: darkTheme ? "none" : 500,
                      }}
                    >
                      Data Preprocessing - Enhanced image quality of Sentinel 2
                      Satellite using ESRGAN and modified its architecture as
                      per business requirements.{" "}
                    </span>
                  </li>
                  <li
                    data-aos="fade-right"
                    data-aos-delay="400"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span
                      style={{
                        color: darkTheme ? "white" : "black",
                        fontWeight: darkTheme ? "none" : 500,
                      }}
                    >
                      Data Preprocessing - Balanced image data using GAN.
                    </span>
                  </li>
                  <li
                    data-aos="fade-right"
                    data-aos-delay="500"
                    style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
                  >
                    <span
                      style={{
                        color: darkTheme ? "white" : "black",
                        fontWeight: darkTheme ? "none" : 500,
                      }}
                    >
                      Built an API for weather usecase which takes input as lat
                      long and return weather report accordingly.{" "}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Experience;
